import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, Info, X } from "lucide-react";
import { format, startOfWeek, addDays, isToday, parseISO } from "date-fns";
import { getData } from "../../api/api";
import { useParams } from "react-router-dom";

export default function MenuFood() {
  // Trạng thái để lưu trữ bữa ăn được chọn
  const [selectedMeal, setSelectedMeal] = useState(null);

  // Trạng thái để lưu trữ ngày hiện tại được chọn
  const [currentDate, setCurrentDate] = useState(new Date());

  // Trạng thái để lưu trữ dữ liệu thực đơn
  const [menuData, setMenuData] = useState([]);

  // Lấy id từ đường dẫn URL
  const { id } = useParams();

  // Hàm cập nhật ngày hiện tại dựa trên dữ liệu thực đơn được tải
  const updateCurrentDate = (menus) => {
    if (menus.length > 0) {
      // Giả sử cookDate ở định dạng 'yyyy-MM-dd'
      const firstCookDate = menus[0].cookDate;
      setCurrentDate(parseISO(firstCookDate));
    }
  };

  // Hiệu ứng phụ để tải dữ liệu thực đơn khi component được render
  useEffect(() => {
    getData("/menu").then((response) => {
      const menuItems = response.data.data;
      console.log("Dữ liệu các mục thực đơn:", menuItems);
      setMenuData(menuItems);
      updateCurrentDate(menuItems);
    });
  }, []);

  // Tính toán ngày bắt đầu của tuần dựa trên ngày hiện tại
  // Tuần bắt đầu từ thứ Hai
  const startOfCurrentWeek = startOfWeek(currentDate, { weekStartsOn: 1 });

  // Hàm mở chi tiết bữa ăn khi được chọn
  const openMealDetails = (meal) => {
    setSelectedMeal(meal);
  };

  // Hàm đóng chi tiết bữa ăn
  const closeMealDetails = () => {
    setSelectedMeal(null);
  };

  // Danh sách các loại bữa ăn
  const dishTypes = ["Breakfast", "Lunch", "Dinner"];

  return (
    <div className="max-w-[1800px] mx-auto p-4 bg-[#f9f7f4]">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-medium text-[#725b53]">
          Weekly Menu from {format(startOfCurrentWeek, "dd.MM.yyyy")} to{" "}
          {format(addDays(startOfCurrentWeek, 6), "dd.MM.yyyy")}
        </h1>

        <div className="flex items-center gap-2">
          <button
            className="p-2 hover:bg-gray-200 rounded"
            onClick={() => setCurrentDate(addDays(currentDate, -7))}
          >
            <ChevronLeft className="w-5 h-5 text-gray-600" />
          </button>
          <button
            className="p-2 hover:bg-gray-200 rounded"
            onClick={() => setCurrentDate(addDays(currentDate, 7))}
          >
            <ChevronRight className="w-5 h-5 text-gray-600" />
          </button>
        </div>
      </div>

      {/* Menu Grid */}
      <div className="overflow-x-auto">
        <div className="min-w-[800px]">
          {/* Days Header */}
          <div className="grid grid-cols-[100px_repeat(7,1fr)] bg-[#e8e1d9]">
            <div className="p-2 font-medium text-[#725b53] border-r border-[#d3c7bc]">
              Dish Type
            </div>
            {[...Array(7)].map((_, index) => {
              const dayDate = addDays(startOfCurrentWeek, index);
              const dayName = format(dayDate, "EEEE");
              return (
                <div
                  key={index}
                  className="p-2 font-medium text-center text-[#725b53] border-r border-[#d3c7bc]"
                >
                     {dayName} <br /> {format(dayDate, "dd.MM.yyyy")}

                </div>
              );
            })}
          </div>

          {/* Meal Slots */}
          {dishTypes.map((dishType) => (
            <div
              key={dishType}
              className="grid grid-cols-[100px_repeat(7,1fr)] border-b border-[#d3c7bc]"
            >
              <div className="p-2 text-sm text-[#725b53] border-r border-[#d3c7bc] bg-[#f3efe9]">
                {dishType}
              </div>
              {[...Array(7)].map((_, index) => {
                const currentDayDate = addDays(startOfCurrentWeek, index);
                const dateStr = format(currentDayDate, "yyyy-MM-dd");

                // Tìm menu cho ngày hiện tại
                const menuForDate = menuData.find(
                  (menuItem) => menuItem.cookDate === dateStr && menuItem.menuName === dishType
                );

                // Tìm các món cho loại món ăn hiện tại
                let meals = [];
                if (menuForDate) {
                  meals = menuForDate.dishes; // Lấy tất cả các món ăn
                }

                const isTodayFlag = isToday(currentDayDate);

                return (
                  <div
                    key={index}
                    className={`p-2 text-sm border-r border-[#d3c7bc] min-h-[80px] max-h-[200px] overflow-y-auto ${
                      isTodayFlag ? "bg-yellow-200" : ""
                    }`}
                  >
                    {meals.map((meal) => (
                      <button
                        key={meal.id} // Giả sử mỗi món ăn có một id duy nhất
                        onClick={() =>
                          openMealDetails({ ...meal, cookDate: dateStr })
                        }
                        className="flex items-start gap-2 w-full text-left hover:bg-[#e8e1d9] p-1 rounded transition-colors"
                      >
                        <span className="flex-1">{meal.name}</span>
                        <Info className="w-4 h-4 text-gray-400 flex-shrink-0" />
                      </button>
                    ))}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>

      {/* Legend */}
      {/* <div className="mt-4 flex gap-4 text-sm text-[#725b53]">
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-[#e8e1d9]"></div>
          <span>Main Dish</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-[#f3efe9]"></div>
          <span>Side Dish</span>
        </div>
      </div> */}

      {/* Meal Details Popup */}
      {selectedMeal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full">
            <div className="flex justify-between items-start mb-4">
              <h2 className="text-xl font-semibold text-[#725b53]">
                {selectedMeal.name}
              </h2>
              <button
                onClick={closeMealDetails}
                className="text-gray-500 hover:text-gray-700"
              >
                <X className="w-6 h-6" />
              </button>
            </div>
            <div className="space-y-2 text-[#725b53]">
              <p>
                <strong>Dish Type:</strong> {selectedMeal.dishTypeName}
              </p>
              <p>
                <strong>Date:</strong> {selectedMeal.cookDate}
              </p>
              <p>
                <strong>Note:</strong> {selectedMeal.note || "No notes"}
              </p>
              <p>
                {/* <strong>Ingredients:</strong> {selectedMeal.name} */}
                {/* {selectedMeal.dishes.map((ing) => ing.name).join(", ")} */}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}